export default __webpack_public_path__ + "static/media/cert-customer-HKIRC.bd9ac8c1.jpg";